import { render, staticRenderFns } from "./MarketplaceProductDetailsRelatedProducts.vue?vue&type=template&id=33a4b2bc&"
import script from "./MarketplaceProductDetailsRelatedProducts.vue?vue&type=script&lang=js&"
export * from "./MarketplaceProductDetailsRelatedProducts.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceProductDetailsRelatedProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports